"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=e(require("styled-components")).default.section`
    padding: 43px 0 0;
    position: relative;

    @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
        padding: 84px 0 76px;

        &::after {
            display: block;
            content: '';
            background: ${({theme:e})=>e.colors.grey[50]};
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 80%;
            z-index: -1;
        }
    }

    > header {
        text-align: center;

        h2 {
            margin: 0 0 17px;

            @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
                margin-bottom: 27px;
            }
        }
    }

    > .content {
        position: relative;

        > .gallery {
            position: relative;

            @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
                max-width: 997px;
                margin: 0 auto;
            }

            .thumbnails {
                display: none;

                @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
                    display: grid;
                }
            }
        }

        .modal-button {
            position: absolute;
            right: 11px;
            color: ${({theme:e})=>e.colors.primary.dark};
            bottom: 11px;
            z-index: 10;
            padding: 10px 8px;
            border-radius: 2px;
            border: none;
            background: ${({theme:e})=>e.colors.primary.dark};
            display: flex;
            flex-direction: row;
            align-items: center;

            svg {
                margin-right: 4px;
            }

            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }

            @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
                display: none;
            }
        }

        > .modal-button {
            background: transparent;
            box-shadow: none;
        }
    }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
